const SoFormStepConfirmation = {
  nameForData: 'SO_FORM_STEP_CONFIRMATION',
};

export default SoFormStepConfirmation;
